import $ from 'jquery';
$(document).ready(function () {
    var touchMoved;

    // Touch Device Detection - when testing make sure you are in Responsive mode NOT screen width.
    var isTouchDevice = 'ontouchstart' in document.documentElement;

    var PRIMARY_NAV_LINK = '.primary-nav__item.is-dropdown > .primary-nav__link';
    var PRIMARY_NAV_BACK_BTN = '.primary-nav__back';
    var MENU_TOGGLE = '.menu-toggle';
    var MAX_BREAKPOINT = 992;

    $('body').on('click', PRIMARY_NAV_BACK_BTN, function () {
        $(this).closest('.primary-nav__item.is-dropdown.is-active').removeClass('is-active');
        checkForActiveChild();
    });

    $('body').on('click', MENU_TOGGLE, function (e) {
        e.preventDefault();
        var $this = $(this);

        $('.primary-nav').addClass('is-active');
        $('body').addClass('mobile-nav-open');
        $('.primary-nav__wrapper').toggleClass('fade-in-out');
        $this.toggleClass('icon-change');

        if ($this.hasClass('icon-change') === false) {
            closeNav();
        }

/*        updateMobileMenuToggle();*/
    });


    $('.primary-nav').on('click tap', PRIMARY_NAV_LINK, function (e) {
        if (window.innerWidth < MAX_BREAKPOINT) {
            e.preventDefault();
            if (touchMoved === true) return; // If scrolling

            var $submenu = $(this).closest('.primary-nav__item.is-dropdown');
            var $currentOpenSubmenus = $('.primary-nav__item.is-dropdown.is-active');

            $('.primary-nav').addClass('is-active');
            $('body').addClass('mobile-nav-open');
            $submenu.addClass('is-active');
            checkForActiveChild();
        }
    }).on('touchmove', function () {
        touchMoved = true;
    }).on('touchstart', function () {
        touchMoved = false;
    });


    // Dynamically generate the back and overview menu links
    (function generateMobileMarkup() {
        $('.primary-nav .is-dropdown').each(function (element, index) {
            var $menu = $(this).find('> .dropdown');
            var $link = $(this).find('> a.primary-nav__link');
            var label = $link.html();

            removeSfPresentationFromHref($link);

            var href = $link.attr('href');

            // Create the markup for back and overview buttons
            var generated = "";
            if (window.innerWidth > 768) {
                generated += '<li class="primary-nav__item  primary-nav__item--tabletSwapSpan" role="none"><a class="primary-nav__link" href="' + href + '" role="menuitem">' + label + '</a></li>';
            }

            generated += '<li class="primary-nav__item flyout__visible" role="none">';
            generated += '<a class="primary-nav__link primary-nav__back" role="menuitem" href="#" aria-label="Back"> </a>';
            generated += '</li>';
            if(!$(this).hasClass("isShortcut")){
                generated += '<li class="primary-nav__item d-lg-none" role="none">';
                generated += '<a class="primary-nav__link primary-nav__mobileParentTitle" href="' + href + '" role="menuitem">' + label +'</a>';
                generated += '</li>';
            }
          

            $menu.prepend(generated);

            $link.addClass('flyout__hidden--sm-md');
        });
    })();




    $('.primary-nav .is-dropdown').hover(function mouseEnterDropdown(e) {
        var $this = $(this);
        setTimeout(function () {
            if (window.innerWidth > 768)
                $this
                    .addClass('open')
                    .find('.dropdown')
                    .attr('aria-expanded', true);
        }, 5);
    }, function mouseLeaveDropdown(e) {
        var $this = $(this);

        setTimeout(function () {
            if (window.innerWidth > 768)
                $this
                    .removeClass('open')
                    .find('.dropdown')
                    .attr('aria-expanded', false);
        }, 5);
    });

    setMobileActiveLevel();
});

//function updateMobileMenuToggle() {
//    var $menuToggle = $('.menu-toggle');
//    var $menuText = $menuToggle.find('.menu-text');

//    if ($menuToggle.hasClass('icon-change')) {
//        updateText = $menuText.attr('data-close-text');
//    } else {
//        updateText = $menuText.attr('data-open-text');
//    }

//    $menuText.text(updateText);
//}

function checkForActiveChild() {
    setTimeout(function () {
        if (isChildActive()) {
            $('body').addClass('mobile-nav--children-active');
        } else {
            $('body').removeClass('mobile-nav--children-active');
        }
    }, 5);
}

function updateNavHeight() {
    var newHeight = $("body").innerHeight() - $("header .header-mobile__top").innerHeight();
    $('header .primary-nav__list').css({ 'height': newHeight });
    $('header .primary-nav_overlay').css({ 'height': $("body").innerHeight() });
}

function updateMenuNavHeight($elem) {
    // var newHeight = $elem.innerHeight();
    // $('header .primary-nav__list').css({ 'height': newHeight });
}

function calculateLongestSubMenu() {
    // var currentMax = 0;
    // $('header .primary-nav__item ul.dropdown').each(function() {
    //     var $this = $(this);
    //
    //     $this.css({ 'height': 'auto' });
    //     var thisHeight = $this.innerHeight();
    //     console.log("menu height", thisHeight);
    //
    //     if (thisHeight > currentMax) {
    //         currentMax = thisHeight;
    //     }
    // });

    var topMenuHeight = $('header .primary-nav__list--1').innerHeight();

    $('header .primary-nav__item ul.dropdown').css({ 'min-height': topMenuHeight, 'height': 'auto' });
    $('header .primary-nav__list').css({ 'height': 'auto' });
}

function isChildActive() {
    return ($('.primary-nav__list--1 .is-dropdown.is-active').length > 0);
}

function closeNav() {
    $('.primary-nav, .primary-nav__item.is-dropdown').removeClass('is-active');
    $('.mobile-nav__toggle').removeClass('icon-change');

/*    updateMobileMenuToggle();*/
    setTimeout(function () {
        $('body').removeClass('mobile-nav-open');
    }, 5);
}

function setMobileActiveLevel() {
    $(".flyout").find(".primary-nav__link--active").parents(".primary-nav__item.is-dropdown").addClass("is-active");
}

function removeTildaFromHref($elem) {
    if (typeof $elem === "undefined") return false;
    var href = $elem.attr('data-href');

    if (href.indexOf('~') >= 0) {
        href = href.substring(1);
        $elem.attr('data-href', href);
    }
}

function removeSfPresentationFromHref($elem) {
    if (typeof $elem === "undefined") return false;
    var href = $elem.attr('href');

    if (href.length > 0 && href.indexOf('SfCtrlPresentation/#') >= 0) {
        $elem.attr('href', '#');
    }
}



